import React, {Component} from "react";
import './index.less'
export default class PortalContentRecommend extends Component{
    constructor(props) {
        super(props)
        this.state = {
            quicklyStartUrl:"https://aecore.glodon.com/docs/chatbot/guide_1_preview.html ",
            contactInformation:"gaozm@glodon.com"
        }
    }

    handleQuicklyStart = () => {
        window.open(this.state.quicklyStartUrl,"_blank ");
    }

    render() {
        let { handleQuicklyStart } = this
        let { contactInformation } = this.state
        return (
            <div className={'portal-content-recommend'}>
                <div className={'portal-content-recommend-content w1200'} id={'portalRecommend'}>
                    <div className={'portal-content-recommend-content-left'}>
                        <h3>广联达睿答平台</h3>
                        <p>广联达对话机器人，从睿答平台开始。</p>
                        <button className={'g-btn g-btn-border'} onClick={handleQuicklyStart}>快速启动</button>
                    </div>
                    <div className={'portal-content-recommend-content-right'}>
                        <h3>联系我们</h3>
                        <p>如有疑问或想要了解更多，欢迎联系我们，获得全面的 1对1咨询服务</p>
                        <p>联系方式：{contactInformation}</p>
                    </div>
                </div>
            </div>
        )
    }
}